import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { PermissionRequest, PermissionResponse } from '../interfaces/security.model';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.baseUrl}/v${environment.apiVersion}/QuoteSecurityRoles/me/permissions`;

  getPermissions(roles: string[]): Observable<PermissionResponse> {
    const payload: PermissionRequest = { roles };
    return this.http.post<PermissionResponse>(this.apiUrl, payload);
  }
}
